import React from "react";

/* eslint-disable react/prop-types */

export const PortalContext = React.createContext({
  // The DOM element we are targeting
  portalNode: null,
  portalNodeId: null,
  // A function for a Child to call when mounting
  onDidMount: null,
  onWillUnmount: null
  // possibly add functions if we want to communicate directly with the portal?
});

export function withPortalContext(Component) {
  /* eslint-disable react/display-name */
  class PortalComponent extends React.Component {
    render() {
      const { forwardedRef, ...rest } = this.props;

      return (
        <PortalContext.Consumer>
          {portalContext => {
            return <Component ef={forwardedRef} {...rest} portalContext={portalContext} />;
          }}
        </PortalContext.Consumer>
      );
    }
  }

  return React.forwardRef((props, ref) => {
    return <PortalComponent {...props} forwardedRef={ref} />;
  });
}
